import { email, object, password, ref, string } from "./base";

// Define the validation schema
export const registration = object({
  username: string.min(6).max(30).required().label("Username"),
  email: email.required(),
  password: password.required(),
  confirmPassword: string
    .valid(ref("password"))
    .required()
    .label("Confirm password")
    .messages({
      "any.only": "Passwords do not match",
    }),
});

export const login = object({
  email: email.required(),
  password: password.required(),
});

export const updateProfile = object({
  name: string.required().label("Name"),
  email: email.required(),
});

export const updatePassword = object({
  currentPassword: password.required().label("Current password"),
  newPassword: password
    .required()
    .custom((value, helpers) => {
      const { currentPassword } = helpers.state.ancestors[0];
      if (currentPassword === value) {
        return helpers.error("any.invalid");
      }
      return value;
    })
    .messages({
      "any.invalid": "Current password must not be the same as new password",
    })
    .label("New password"),
  confirmPassword: string
    .valid(ref("newPassword"))
    .required()
    .label("Confirm password")
    .messages({
      "any.only": "Passwords do not match",
    }),
});
